<template>
  <div class="i-plan-options">
    <div
      v-if="!isTabletOrLarger"
      class="intro-coach"
    >
      <div class="heading">Your Career Coach</div>
      <div class="intro">
        <div class="one">
          <div class="coach">
            <img
              alt="Your coach's picture"
              :src="assignedCoach?.profilePhotoUrl || ''"
            />
            <div>
              <div class="name">{{ assignedCoachFirstName }}</div>
              <div>Expert Career Coach</div>
            </div>
          </div>
          <div class="rating">
            <img
              alt="5 stars rating"
              :src="iconStar"
            />
            {{ assignedCoach?.rating }} stars
          </div>
        </div>
        <div class="two">
          <div class="pulse-circle"></div>
          <div>Accepting just {{ slotsLeft }} new clients this month.</div>
        </div>
        <div
          class="three"
          @click="GlobalFunctions.scrollInToElement('#coach-summary-section')"
        >
          Check {{ assignedCoachFirstName }}'s Bio and Specialties <img :src="iconChevronRight" />
        </div>
      </div>
    </div>

    <div class="plans">
      <div
        v-if="visiblePlans.length > 1"
        class="heading"
      >
        <div
          v-if="!isTabletOrLarger"
          class="badge special"
        >
          Special Offer
        </div>
        Select Your Plan
        <div
          class="subheading"
          :style="{ maxWidth: '400px' }"
        >
          Most clients start with the Core plan and adjust the frequency of meetings as needed.
        </div>
      </div>
      <div
        id="plan-section"
        class="plan-wrapper"
      >
        <template
          v-for="coachingPlan in coachingPlans"
          :key="coachingPlan?.id"
        >
          <div
            v-if="coachingPlan && coachingPlan.isVisible"
            class="plan-wrap"
          >
            <div
              class="plan"
              :class="{ active: props.chosenPlan === coachingPlan.id }"
              @click="$emit('planSelected', coachingPlan.id)"
            >
              <div class="inner">
                <div class="top">
                  <div class="first">
                    <div class="info">
                      <div class="plan-title-wrapper">
                        <div
                          v-if="coachingPlan.id === StripePrice.COACHING_CORE"
                          class="badge popular mobile-badge"
                        >
                          <div class="most-popular">
                            <span v-if="!isDesktopOrLarger || isXlOrLarger">Most </span>Popular
                          </div>
                        </div>
                        <div
                          v-if="coachingPlan.subtitle"
                          class="plan-subtitle"
                        >
                          {{ coachingPlan.subtitle }}
                        </div>
                        <div class="plan-title">{{ coachingPlan.title }}</div>
                      </div>
                    </div>
                    <div class="badge-radio-wrapper">
                      <div
                        v-if="coachingPlan.id === StripePrice.COACHING_CORE"
                        class="badge popular desktop-badge"
                      >
                        <div class="most-popular">
                          <span v-if="!isDesktopOrLarger || isXlOrLarger">Most </span>Popular
                        </div>
                      </div>
                      <img
                        class="radio"
                        :src="props.chosenPlan === coachingPlan.id ? iconFilledRadio : iconEmptyRadio"
                      />
                    </div>
                  </div>
                  <div class="price-section">
                    <div class="price">
                      <span
                        v-if="coachingPlan.discounted"
                        class="discounted"
                      >
                        ${{ coachingPlan.discounted }}
                      </span>
                      <span>${{ coachingPlan.price }}<span v-if="coachingPlan.isSubscription">/month</span></span>
                    </div>
                    <div
                      v-if="coachingPlan.off"
                      class="off"
                    >
                      {{ coachingPlan.off }} Off
                    </div>
                  </div>
                </div>
                <div class="list">
                  <ul>
                    <template v-if="!Array.isArray(coachingPlan.details)">
                      <li
                        v-for="detail in Object.keys(coachingPlan.details)"
                        :key="detail"
                        class="detail"
                        :class="{ tick: coachingPlan.details[detail] }"
                        :innerHTML="detail"
                      />
                    </template>
                    <template v-else>
                      <li
                        v-for="detail in coachingPlan.details"
                        :key="detail"
                        class="detail tick"
                        :innerHTML="detail"
                      />
                    </template>
                  </ul>
                </div>
              </div>
            </div>
            <div
              v-if="!!coachingPlan.renews"
              class="renews"
            >
              Renews at ${{ coachingPlan.renews }}/month
            </div>
            <div
              v-else-if="!!props.discountIdentifier"
              class="renews"
            >
              Discount may apply at checkout with a valid promo code
            </div>
          </div>
        </template>
      </div>
    </div>
    <iCoachSummary v-if="props.isUnpaidExecutiveCoaching" />
    <div
      v-if="!userStore.userData.hasResumePackage && !props.isUnpaidExecutiveCoaching"
      class="plans"
    >
      <div class="heading">
        Add a Resume Package
        <div class="subheading">Optimize your job search toolkit with a professional resume writer</div>
      </div>
      <div
        v-if="isDesktopOrLarger"
        class="row-list"
      >
        <div class="detail tick">Professionally Written Resume</div>
        <div class="detail tick">Resume ATS Optimization</div>
        <div class="detail tick">Ultimate LinkedIn Checklist</div>
        <div class="detail tick">Dedicated Resume Writer</div>
        <div class="detail tick">30min Coach Strategy Session</div>
      </div>
      <div
        id="plan-section"
        class="plan-wrapper resume-addon"
      >
        <div class="plan-wrap resume-addon">
          <div
            class="plan"
            :class="{ active: props.addonSelected }"
            @click="$emit('addonToggled', true)"
          >
            <div class="inner">
              <div class="top">
                <div class="first">
                  <div class="info">Resume Package</div>
                  <img
                    class="radio"
                    :src="props.addonSelected ? iconFilledRadio : iconEmptyRadio"
                  />
                </div>
                <div class="price-section">
                  <div class="price">
                    <span class="discounted"> $499.90 </span>
                    <span>$299.90</span>
                  </div>
                </div>
                <div class="highlight">Helped over 54k customers</div>
              </div>
              <div
                v-if="!isDesktopOrLarger"
                class="list"
              >
                <ul>
                  <li class="detail tick">Professionally Written Resume</li>
                  <li class="detail tick">Resume ATS Optimization</li>
                  <li class="detail tick">Ultimate LinkedIn Checklist</li>
                  <li class="detail tick">Dedicated Resume Writer</li>
                  <li class="detail tick">30min Coach Strategy Session</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="plan-wrap resume-addon">
          <div
            class="plan"
            :class="{ active: !props.addonSelected }"
            @click="$emit('addonToggled', false)"
          >
            <div
              class="inner"
              :style="{ justifyContent: 'center' }"
            >
              <div class="top">
                <div class="first">
                  <div class="info">Not Interested</div>
                  <img
                    class="radio"
                    :src="!props.addonSelected ? iconFilledRadio : iconEmptyRadio"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useCoachingStore } from "@/stores/coaching"
import { useUserStore } from "@/stores/user"
import { breakpointLg, breakpointMd, breakpointXl } from "@/styles/variables"

import useRandomNumber from "@/composables/useRandomNumber"
import useIsScreenSize from "@/composables/useIsScreenSize"
import { GlobalFunctions } from "@/helpers/globalFunctions"

import iCoachSummary from "@/components/coaching/selectPlan/CoachSummary.vue"

// ASSETS
import iconEmptyRadio from "@/assets/icons/icon-empty-radio.svg"
import iconFilledRadio from "@/assets/icons/icon-filled-radio.svg"
import iconChevronRight from "@/assets/icons/icon-chevron-right-blue.svg"
import iconStar from "@/assets/icons/icon-single-slashed-star.svg"

//TYPES
import StripePrice from "@/shared/enums/StripePrice"
import type { CoachingPlans } from "@/types"

// EMITS
defineEmits(["planSelected", "addonToggled"])

// STORES AND COMPOSABLES
const userStore = useUserStore()
const coachingStore = useCoachingStore()
const isTabletOrLarger = useIsScreenSize(breakpointMd)
const isDesktopOrLarger = useIsScreenSize(breakpointLg)
const isXlOrLarger = useIsScreenSize(breakpointXl)
const slotsLeft = useRandomNumber(userStore.getFullName || "Full Name", 3, 5)

// PROPS
const props = defineProps({
  coachingPlans: {
    type: Object as () => CoachingPlans,
    required: true
  },
  chosenPlan: {
    type: String as () => StripePrice,
    required: true
  },
  addonSelected: {
    type: Boolean,
    required: true
  },
  isUnpaidExecutiveCoaching: {
    type: Boolean,
    default: false
  },
  discountIdentifier: {
    type: String,
    default: null
  }
})

// COMPUTED
const assignedCoach = computed(() => coachingStore.getAssignedCoach)
const assignedCoachFirstName = computed(() => assignedCoach.value?.fullName?.split(" ")[0])
const visiblePlans = computed(() =>
  Object.keys(props.coachingPlans).filter((p) => props.coachingPlans[p as StripePrice]?.isVisible)
)
</script>

<style lang="scss" scoped>
.i-plan-options {
  @include flex(column, start, stretch, $gap: 15px);

  padding: 0 20px;

  @media screen and (min-width: $breakpoint-lg) {
    @include flex(column, start, center, $gap: 15px);
  }

  .badge {
    @include border-radius-xxl;
    @include text-sm;

    text-transform: uppercase;
    width: fit-content;

    &.special {
      background-color: $azure-radiance100;
      color: $azure-radiance600;
      padding: 4px 8px;
      font-weight: 500;
    }

    &.popular {
      @include text-xs;

      background-image: $blue-purple-gradient;
      font-weight: 700;

      .most-popular {
        @include border-radius-xxl;

        padding: 4px 8px;
        background-color: #ffffffda;
        mix-blend-mode: screen;
      }
    }
  }

  .heading {
    @include flex(column, start, start, $gap: 6px);
    @include text-xl;

    font-weight: 700;
    text-align: left;

    @media screen and (min-width: $breakpoint-md) {
      @include display-xs;

      align-items: center;
      text-align: center;
    }

    .subheading {
      @include text-sm;

      font-weight: 400;

      @media screen and (min-width: $breakpoint-md) {
        @include text-md;
      }
    }
  }

  .intro-coach {
    @include flex(column, start, stretch, $gap: 20px);

    margin-top: 35px;

    .intro {
      @include border-radius-lg;
      @include text-sm;

      width: 100%;
      border: 1px solid $zumthor100;
      background-color: $white;
      padding: 20px;

      > div {
        &:not(:last-child) {
          padding-bottom: 8px;
          border-bottom: 1px solid $zumthor100;
        }

        &:not(:first-child) {
          padding-top: 8px;
        }
      }

      .one {
        @include flex(row, space-between, start, $gap: 8px);

        .coach {
          @include flex(row, start, center, $gap: 8px);

          .name {
            @include text-lg;

            font-weight: 600;
          }

          img {
            @include border-radius-rounded;

            width: 38px;
          }
        }

        .rating {
          font-weight: 700;

          img {
            vertical-align: text-bottom;
          }
        }
      }

      .two {
        @include flex(row, start, center, $gap: 8px);

        color: $comet700;

        .pulse-circle {
          @include border-radius-rounded;

          width: 10px;
          height: 10px;
          background-color: $azure-radiance600;
          position: relative;

          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 #068eff29;
            }

            50% {
              box-shadow: 0 0 0 5px #068eff29;
            }

            100% {
              box-shadow: 0 0 0 0 #068eff29;
            }
          }

          &::after {
            @include border-radius-rounded;

            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            z-index: 1;
            animation: pulse 2s forwards infinite;
            animation-timing-function: linear;
          }
        }
      }

      .three {
        @include flex(row, space-between, stretch, $gap: 5px);

        text-decoration: underline;
        color: $azure-radiance600;
        cursor: pointer;
      }
    }
  }

  .plans {
    @include flex(column, start, stretch, $gap: 30px);
    @include text-sm;

    margin-top: 35px;
    font-weight: 400;

    @media screen and (min-width: $breakpoint-lg) {
      @include flex(column, start, center, $gap: 30px);
    }

    .detail {
      @include flex(row, start, center);

      color: $comet400;
      list-style: none;

      &::before {
        content: "";
        display: inline-block;
        height: 20px;
        width: 25px;
        background-image: url("@/assets/icons/icon-grey-close.svg");
        background-repeat: no-repeat;
      }

      &.tick {
        color: $black950;

        &::before {
          background-image: url("@/assets/icons/icon-green-check.svg");
        }
      }
    }

    .row-list {
      @include flex(row, center, center, wrap, $gap: 6px 20px);
    }

    .plan-wrapper {
      @include flex(column, center, stretch, $gap: 18px);

      @media screen and (min-width: $breakpoint-lg) {
        @include flex(row, center, start, wrap, $gap: 18px);
      }

      &.resume-addon {
        @media screen and (min-width: $breakpoint-lg) {
          @include flex(row, center, stretch, wrap, $gap: 18px);
        }
      }

      .plan-wrap {
        @include flex(column, center, center, $gap: 8px);

        &.resume-addon {
          @media screen and (min-width: $breakpoint-lg) {
            @include flex(row, center, stretch, wrap, $gap: 18px);
          }
        }

        .plan {
          @include border-radius-lg;

          width: 100%;
          max-width: 700px;
          border: 1px solid $zumthor100;
          background-color: $white;
          cursor: pointer;
          padding: 4px;

          @media screen and (min-width: $breakpoint-lg) {
            width: 400px;
          }

          .inner {
            @include flex(column, start, stretch);

            height: 100%;

            > div {
              padding: 20px;
            }

            .top {
              @include flex(column, start, stretch, $gap: 6px);

              .first {
                @include flex(row, space-between, start, $gap: 6px);

                .info {
                  @include flex(column, start, start, $gap: 2px);
                  @include text-lg;

                  font-weight: 600;
                  flex: 1;

                  .plan-title-wrapper {
                    @include flex(column, start, start, $gap: 1px);
                  }

                  .plan-title {
                    @include text-xl;

                    font-weight: 600;
                  }

                  .plan-subtitle {
                    @include text-xs;

                    font-weight: 500;
                    color: $comet400;
                    text-transform: uppercase;
                  }

                  .mobile-badge {
                    margin-bottom: 4px;
                    align-self: flex-start;

                    @media screen and (min-width: $breakpoint-xs) {
                      display: none;
                    }
                  }
                }

                .badge-radio-wrapper {
                  @include flex(row, end, center, $gap: 8px);

                  flex: 0 0 auto;

                  .desktop-badge {
                    display: none;

                    @media screen and (min-width: $breakpoint-xs) {
                      display: block;
                    }
                  }

                  .radio {
                    width: 20px;
                    flex: 0 0 20px;
                  }
                }
              }

              .highlight {
                @include text-xs;

                font-weight: 700;
                color: $bittersweet400;
                white-space: nowrap;
              }

              .price-section {
                @include flex(row, space-between, center, wrap, $gap: 8px);

                .price {
                  @include flex(row, start, center, $gap: 6px);
                  @include text-lg;

                  font-weight: 600;

                  .discounted {
                    font-weight: 400;
                    text-decoration: line-through;
                    color: $comet400;
                  }
                }

                .off {
                  @include text-xs;

                  font-weight: 700;
                  color: $bittersweet400;
                  white-space: nowrap;
                }
              }
            }

            .list {
              @include flex(column, start, stretch);

              border-top: 1px solid $zumthor100;

              ul {
                margin: 0;
                padding-left: 0;

                li.detail {
                  &:not(:last-child) {
                    padding-bottom: 8px;
                    border-bottom: 1px solid $zumthor100;
                  }

                  &:not(:first-child) {
                    padding-top: 8px;
                  }
                }
              }
            }
          }

          &.active {
            background-image: $blue-purple-gradient;

            .inner {
              border-radius: 20px;
              background-color: white;
            }
          }
        }

        .renews {
          @include text-xs;

          color: $comet600;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.i-plan-options {
  .plans {
    .plan-wrapper {
      .plan {
        .detail {
          > span {
            @include flex(row, start, center, $gap: 5px);
          }

          > div {
            @include flex(row, space-between, center, wrap, 5px);

            width: 100%;
          }
        }
      }
    }
  }
}
</style>
